import { ApplicationState } from '@app/store'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { FeedbackButton } from '../components/FeedbackButton'
import {
  actionCreators,
  IFeedbackState,
  selectFeedbackText,
  selectFeedbackType,
  selectIsOpen,
  selectIsSaving,
} from '../modules/feedback'

export default connect(
  createStructuredSelector<ApplicationState, IFeedbackState>({
    feedbackText: selectFeedbackText(),
    feedbackType: selectFeedbackType(),
    isOpen: selectIsOpen(),
    isSaving: selectIsSaving(),
  }),
  actionCreators,
)(FeedbackButton)
